module.exports = __webpack_public_path__ + "img/bg3.4eda3800.png";